import React, { useState, useMemo, useEffect, useRef } from "react";
import CustomTable from '../../common/CustomTable';
import { Select, DatePicker, Spin, message, Button, Dropdown, Space } from 'antd';
import { Timesheetapi } from "../../../middleware/interceptor";
import dayjs from 'dayjs';
import * as moment from 'moment';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import CryptoJS from 'crypto-js';
import customParseFormat from "dayjs/plugin/customParseFormat";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { SdCard } from "@mui/icons-material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { DownOutlined, CheckOutlined } from '@ant-design/icons';


const { Option } = Select;
const { RangePicker } = DatePicker;


export function Employee_report({ Secret_key, sidebor }) {


  const [selectedTimePeriod, setSelectedTimePeriod] = useState('week');
  const [loading, setloading] = useState(true)
  let currentStartDate = dayjs().startOf(selectedTimePeriod)
  let currentEndDate = dayjs().endOf(selectedTimePeriod);
  const [selectedDates, setSelectedDates] = useState([
    currentStartDate,
    currentEndDate,
  ]);
  const [sDate, setSdate] = useState(currentStartDate.format("YYYY-MM-DD"))
  const [eDate, setEdate] = useState(currentEndDate.format("YYYY-MM-DD"))

  const [selectedWeekDates, setSelectedWeekDates] = useState([]);
  const [dateList, setDateList] = useState([]);
  const today = new Date();
  const [messageApi, contextHolder] = message.useMessage();
  const [Employee, setEmployee] = useState()
  const [ProjectList, setProjectList] = useState()
  const [Temp, setTemp] = useState([])

  const [selectedEmployee, setselectedEmployee] = useState()
  const [selectedProject, setselectedProject] = useState()
  const [rawData, setRawData] = useState([]);

  const [totalHours, setTotalHours] = useState()

  const noDataWarning = () => {
    messageApi.open({
      type: 'warning',
      content: 'No data to download',
    });
  };


  //For employee report
  const [employeelist, setemployeelist] = useState([])

  const handleTimePeriodChange = (value) => {
    // setSelectedStatus('All');
    // setSelectedPriority('All');
    setSelectedTimePeriod(value)
    const currentStartDate = dayjs().startOf(value);
    const currentEndDate = dayjs().endOf(value);
    setSelectedDates([
      currentStartDate,
      currentEndDate,
    ])
  }








  const formatTime = (totalMinutes) => {
    if (isNaN(totalMinutes) || totalMinutes == null) return "00:00"; // Handle NaN or null
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };


  useEffect(() => {

    if (Secret_key != null && Secret_key != "") {
    }
  }, [Secret_key]);



  // //Dropdown and Functionalities for Status and Priority

  const [selectedGrouping, setSelectedGrouping] = useState('None');
  // const [selectedPriority, setSelectedPriority] = useState('All');
  const getCommentsHeader = () => {

    const items = ['None', 'Group by Task'].map((item) => ({
      label: (
        <span style={{
          width: '100%',
          fontWeight: selectedGrouping === item ? 'bold' : 'normal',
          color: selectedGrouping === item ? '#1677ff' : 'Black',
        }}
        >
          {item}
        </span>
      ),
      key: item,
    }));

    const handleCommentsMenuClick = (info) => {
      setSelectedGrouping(info.key);
      console.log('Selected:', info.key); // <-- Here you get the selected key
    };

    return (
      <Dropdown
        menu={{ items, onClick: handleCommentsMenuClick }}
        trigger={['click']}
        className="w-full h-full cursor-pointer"
      >
        <a onClick={e => e.preventDefault()} className="hover:text-blue-500">
          <Space>
            Comments<DownOutlined />
          </Space>
        </a>
      </Dropdown>
    );

  }


  const getNoCommentHrs = (totalTaskHrs, allCommentsHrs) => {

    const totalCommentMins = allCommentsHrs.reduce((sum, timeStr) => {
      const [h, m] = timeStr.split(':').map(Number);
      return sum + h * 60 + m;
    }, 0);

    const remainingMins = totalTaskHrs - totalCommentMins;
    console.log("QAZXSW", totalTaskHrs, allCommentsHrs, formatTime(remainingMins));
    return remainingMins;
  };

  const columns = useMemo(() => [

    {
      accessorKey: 'client_name',
      header: 'Client',
      size: 100,
      enableColumnActions: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
    },

    {
      accessorKey: 'project_name',
      header: 'Projects',
      size: 50,
      enableColumnActions: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
    },

    {
      accessorKey: 'Task_name',
      header: 'Tasks',
      size: 200,
      enableColumnActions: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
    },
    {
      accessorKey: 'comments_data',
      header: getCommentsHeader(),
      size: 250,
      enableColumnActions: false,
      enableSorting: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        style: {
          textAlign: 'justify',
        },
      },
    },
    {
      accessorKey: 'Hours',
      header: 'Hours',
      size: 80,
      enableColumnActions: false,
      muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        style: {
          textAlign: 'right',
        },
      },

    },


  ], [employeelist]);



  const options = [
    { label: 'Day Report', value: 'date' },
    { label: 'Weekly Report', value: 'week' },
    { label: 'Monthly Report', value: 'month' },
    { label: 'Yearly Report', value: 'year' }
  ];

  useEffect(() => {
    const initialRender = async () => {

      if (selectedTimePeriod === 'month' || selectedTimePeriod === 'year') {
        currentStartDate = dayjs().startOf(selectedTimePeriod);
        currentEndDate = dayjs().endOf(selectedTimePeriod);
      } else if (selectedTimePeriod === 'date') {
        currentStartDate = dayjs().startOf('day');
        currentEndDate = dayjs().endOf('day');
      }
      setSdate(currentStartDate.format("YYYY-MM-DD"));
      setEdate(currentEndDate.format("YYYY-MM-DD"));
    }
    initialRender();
  }, [selectedTimePeriod]);


  useEffect(() => {
    const getemployeereport = async () => {
      setloading(true);
      try {
        const response = await Timesheetapi.get(
          `api/Projects/employeegetreportsAsync?sdate=${sDate}&edate=${eDate}&Roleid=${localStorage.getItem('emp_role_id')}&empId=${localStorage.getItem('employee_id')}`
        );

        const employees = response.data.employeedetails;



        const GetEmployee = employees.map((employee) => ({
          label: employee.Employee_name,
          value: employee.Employee_id
        }));

        GetEmployee.unshift({ value: 1, label: 'All' });

        const projectMap = new Map();

        employees.forEach((employee) => {
          employee.Projects.forEach((proj) => {
            if (!projectMap.has(proj.Project_id)) {
              projectMap.set(proj.Project_id, {
                label: proj.Project_name.includes('/') ? proj.Project_name.split('/')[1].trim() : proj.Project_name,
                value: proj.Project_id
              });
            }
          });
        });

        const Projectlist = Array.from(projectMap.values());

        setProjectList([{ label: 'All', value: 1 }]);
        setEmployee(GetEmployee);
        setselectedEmployee(selectedEmployee ? selectedEmployee : GetEmployee[0].value);
        setTemp(employees)
        console.log("rawDatatempData", employees)
        const formattedEmployees = employees.map(emp => {
          const allTasks = emp.Projects.flatMap(project =>
            project.Tasks.map(task => ({
              project: project.Project_name,
              task: task.Task_name,
              hours: task.Hours,
            }))
          );

          const mergedProjects = [...new Set(allTasks.map(t => t.project))].join(', ');
          const mergedTasks = allTasks.map(t => t.task).join(', ');
          const totalHours = allTasks.reduce((sum, t) => sum + t.hours, 0);

          return {
            Employee_name: emp.Employee_name,
            Role: emp.Role,
            Projects: mergedProjects,
            Tasks: mergedTasks,
            Total_hours: formatTime(totalHours),
          };
        });

        console.log(formattedEmployees, 'employees');
        // setemployeelist(formattedEmployees);
      } catch (error) {
        console.error('Error fetching employee report:', error);
      } finally {
        setloading(false);
        setselectedEmployee(1);
      }
    };

    getemployeereport();
  }, [sDate, eDate]);




  const handleDateChange = (date, dateString) => {
    // setSelectedStatus('All');
    // setSelectedPriority('All');
    // setloading(true);
    if (date && date.length === 2) {
      const startMonth = date[0];
      const endMonth = date[1];

      const startOfMonth = startMonth.startOf(selectedTimePeriod).format("YYYY-MM-DD");
      const endOfMonth = endMonth.endOf(selectedTimePeriod).format("YYYY-MM-DD");

      setSelectedDates([startMonth, endMonth]);
      setSdate(startOfMonth);
      setEdate(endOfMonth);
    }
  };


  const formatDateToDDMMYYYY = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Format as yyyy-mm-dd
  };

  const handleWeekSelection = (selectedDates_, dateStr, instance) => {
    // setSelectedStatus('All');
    // setSelectedPriority('All');
    if (instance) { instance.close(); }
    if (selectedDates_.length > 0) {
      const selectedTempDate = selectedDates_[0];
      const startOfWeek = new Date(selectedTempDate);
      const dayOfWeek = startOfWeek.getDay();
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      startOfWeek.setDate(startOfWeek.getDate() - daysToMonday);
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      setSelectedWeekDates([startOfWeek, endOfWeek]);
      setSdate(formatDateToDDMMYYYY(new Date(startOfWeek)));
      setEdate(formatDateToDDMMYYYY(new Date(endOfWeek)));
      console.log("ytrew", [formatDateToDDMMYYYY(new Date(startOfWeek)), formatDateToDDMMYYYY(new Date(endOfWeek))]);
      const newDateList = Array.from({ length: 7 }, (_, index) => {
        const date = new Date(startOfWeek);
        date.setDate(startOfWeek.getDate() + index);
        const formattedDate = date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric",
        });

        return {
          accessorKey: formattedDate,
          header: formattedDate,
        };
      });
      setDateList(newDateList);
    }
  };

  useEffect(() => {
    if (selectedTimePeriod === 'week') {
      handleWeekSelection([today]);
      const week_selectedDate = today;
      const week_startOfWeek = new Date(week_selectedDate);
      const week_dayOfWeek = week_startOfWeek.getDay();
      const daysToMonday = week_dayOfWeek === 0 ? 6 : week_dayOfWeek - 1;
      week_startOfWeek.setDate(week_startOfWeek.getDate() - daysToMonday);
      const week_endOfWeek = new Date(week_startOfWeek);
      week_endOfWeek.setDate(week_startOfWeek.getDate() + 6);
      setSelectedWeekDates([week_startOfWeek, week_endOfWeek]);
      setSdate(formatDateToDDMMYYYY(new Date(week_startOfWeek)));
      setEdate(formatDateToDDMMYYYY(new Date(week_endOfWeek)));
    }
  }, [selectedTimePeriod]);

  const handleExportData = (data, sdate, edate, selectedTimePeriod) => {
    if (employeelist.length > 0) {
      const employeename = selectedEmployee === 1 ? "All Employees" : Employee.find(employee => employee.value === selectedEmployee);
      const projectname = selectedProject === 1 ? "All Projects" : ProjectList.find(project => project.value === selectedProject);
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Employee Report');

      const formatDateRange = (start, end, type) => {
        const s = new Date(start);
        const e = new Date(end);
        switch (type) {
          case 'date':
            return `DATE: ${s.toDateString()} - ${e.toDateString()}`;
          case 'week':
            return `WEEK: ${s.toDateString()} - ${e.toDateString()}`;
          case 'month':
            return `MONTH: ${s.toLocaleString('en-US', { month: 'long', year: 'numeric' })} - ${e.toLocaleString('en-US', { month: 'long', year: 'numeric' })}`;
          case 'year':
            return `YEAR: ${s.getFullYear()} - ${e.getFullYear()}`;
          default:
            return `${s.toDateString()} - ${e.toDateString()}`;
        }
      };

      const title = formatDateRange(sdate, edate, selectedTimePeriod);

      // Row 1: CLIENT NAME
      worksheet.mergeCells('A1:E1');
      const headerCell = worksheet.getCell('A1');
      headerCell.value = `${selectedEmployee === 1 ? employeename : employeename.label} / ${selectedProject === 1 ? projectname : projectname.label}`;
      headerCell.font = { bold: true, size: 14 };
      headerCell.alignment = { horizontal: 'center', vertical: 'middle' };

      // Row 2: TITLE
      worksheet.mergeCells('A2:E2');
      const titleCell = worksheet.getCell('A2');
      titleCell.value = title;
      titleCell.font = { bold: true, size: 12 };
      titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

      // Row 3: Headers
      worksheet.addRow(['Client', 'Projects', 'Tasks', 'Comments', 'Hours']);
      worksheet.columns = [
        { key: 'Client', width: 30 },
        { key: 'Projects', width: 40 },
        { key: 'Tasks', width: 60 },
        { key: 'Comments', width: 80 },
        { key: 'Total_hours', width: 20 },
      ];
      worksheet.getRow(3).font = { bold: true };

      let totalMinutes = 0;

      data.forEach((row) => {
        // Accumulate total minutes
        if (row.Hours && typeof row.Hours === 'string') {
          const [h, m] = row.Hours.split(':').map(Number);
          totalMinutes += (h * 60 + (m || 0));
        }

        // Add data row
        worksheet.addRow({
          Client: row.client_name,
          Projects: row.project_name,
          Tasks: row.Task_name,
          Comments: row.comments_data || "No Comments",
          Total_hours: row.Hours,
        });
      });

      // Compute total hours as HH:MM
      const totalHours = `${String(Math.floor(totalMinutes / 60)).padStart(2, '0')}:${String(totalMinutes % 60).padStart(2, '0')}`;

      // Add total row
      const totalRow = worksheet.addRow(['', '', '', '', totalHours]);
      const rowNum = totalRow.number;

      // Merge A-D for label
      worksheet.mergeCells(`A${rowNum}:D${rowNum}`);
      const totalLabelCell = worksheet.getCell(`A${rowNum}`);
      totalLabelCell.value = 'Overall Total';
      totalLabelCell.font = { bold: true };
      totalLabelCell.alignment = { horizontal: 'center', vertical: 'middle' };
      totalLabelCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };

      const totalValueCell = worksheet.getCell(`E${rowNum}`);
      totalValueCell.value = totalHours;
      totalValueCell.font = { bold: true };
      totalValueCell.alignment = { horizontal: 'right', vertical: 'middle' };
      totalValueCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D9D9D9' },
      };

      // Align and style all data cells
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });

        if (rowNumber > 3 && rowNumber < rowNum) {
          row.eachCell((cell, colNumber) => {
            let horizontal = colNumber === 5 ? 'right' : 'left';
            cell.alignment = { horizontal, vertical: 'middle', wrapText: true };
          });
        }
      });

      // Medium border for total row
      totalRow.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });

      // Add Client Summary sheet
      const clientSummary = {};
      data.forEach((row) => {
        const client = row.client_name || 'Unknown';
        if (!clientSummary[client]) {
          clientSummary[client] = 0;
        }
        if (row.Hours && typeof row.Hours === 'string') {
          const [h, m] = row.Hours.split(':').map(Number);
          clientSummary[client] += (h * 60 + (m || 0));
        }
      });

      const summaryWorksheet = workbook.addWorksheet("Client Summary");
      summaryWorksheet.columns = [
        { header: "Client Name", key: "client", width: 30 },
        { header: "Total Hours", key: "hours", width: 15 },
      ];

      // Title
      summaryWorksheet.mergeCells('A1:B1');
      const summaryTitleCell = summaryWorksheet.getCell('A1');
      summaryTitleCell.value = "Client-wise Hours Summary";
      summaryTitleCell.font = { bold: true, size: 14 };
      summaryTitleCell.alignment = { horizontal: 'center', vertical: 'middle' };

      summaryWorksheet.getRow(2).font = { bold: true };

      let summaryRowIndex = 3;
      let totalClientMinutes = 0;
      Object.entries(clientSummary).forEach(([client, minutes]) => {
        const hoursFormatted = `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;
        summaryWorksheet.addRow({
          client: client,
          hours: hoursFormatted,
        });
        totalClientMinutes += minutes;
      });

      // Total row
      const totalClientHours = `${String(Math.floor(totalClientMinutes / 60)).padStart(2, '0')}:${String(totalClientMinutes % 60).padStart(2, '0')}`;
      const totalSummaryRow = summaryWorksheet.addRow(['Overall Total', totalClientHours]);
      const summaryRowNum = totalSummaryRow.number;
      summaryWorksheet.getCell(`A${summaryRowNum}`).font = { bold: true };
      summaryWorksheet.getCell(`B${summaryRowNum}`).font = { bold: true };
      summaryWorksheet.getCell(`B${summaryRowNum}`).alignment = { horizontal: 'right' };

      // Borders
      summaryWorksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      });

      // Export the Excel file
      workbook.xlsx.writeBuffer().then((buffer) => {
        const capitalizedPeriod = selectedTimePeriod === "date" ? "Days" : `${selectedTimePeriod.charAt(0).toUpperCase() + selectedTimePeriod.slice(1)}ly`;
        const filename = `${capitalizedPeriod}_${selectedEmployee === 1 ? "All" : employeename.label}_Employee_Report_${sdate}_to_${edate}.xlsx`;
        saveAs(new Blob([buffer]), filename);
      });
    } else {
      noDataWarning();
    }
  };




  const HandleEmployee = (value) => {
    // setSelectedStatus('All');
    // setSelectedPriority('All');
    // const selectedEmployee = Temp.find((emp) => emp.Employee_id === value);
    // const proj = selectedEmployee ? selectedEmployee.Projects : [];

    setselectedEmployee(value);
    setselectedProject(1)
  };

  const handletablevaluechange = (value) => {
    // setSelectedStatus('All');
    // setSelectedPriority('All');
    setselectedProject(value)
  }
  const parseDateString = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return isNaN(date) ? null : date;
  };

  useEffect(() => {
    console.log(selectedEmployee, selectedProject, sDate && eDate, "guuuuu");

    if (Temp.length <= 0) {
      setRawData([]);
      return;
    }

    if (selectedEmployee && selectedProject && sDate && eDate && Temp) {
      setSelectedGrouping('None');

      const selectedEmp = Temp.find((emp) => emp.Employee_id === selectedEmployee);
      const selectedEmsp = Temp.filter(emp => selectedEmployee == 1 || emp.Employee_id == selectedEmployee);



      let EmpList = [];
      let totalhours = 0;

      if (selectedEmsp && selectedEmsp.length > 0) {
        const allProjects = selectedEmsp.flatMap(emp => emp?.Projects || []);

        // Set project list
        // Filter selected employee's projects
        const selectedEmployeeProjects = selectedEmsp
          .filter(emp => emp?.Employee_id === selectedEmployee)
          .flatMap(emp => emp?.Projects || []);

        // Set project list
        const projectOptions = [
          { label: 'All', value: 1 },
          ...selectedEmployeeProjects.map((p) => ({
            label: p.Project_name.includes('/')
              ? p.Project_name.split('/')[1].trim()
              : p.Project_name,
            value: p.Project_id,
          })),
        ];

        setProjectList(projectOptions);


        const filterData = selectedEmsp.flatMap(item => {
          const proj = item?.Projects || [];

          const selectedPro = proj.find((p) => p.Project_id === selectedProject);
          const Tasks = selectedPro?.Tasks || [];

          if (Tasks.length > 0) {
            return Tasks.map((task) => {
              totalhours += task?.Hours || 0;
              return {
                client_name: selectedPro?.Project_name.includes('/') ? selectedPro?.Project_name.split('/')[0].trim() : '',
                project_name: selectedPro?.Project_name.includes('/') ? selectedPro?.Project_name.split('/')[1].trim() : selectedPro?.Project_name,
                Task_name: task?.Task_name,
                Priority: task?.Priority,
                Status: task?.Status,
                Hours: task?.Hours && formatTime(task.Hours),
                Task_comments: task?.Task_comments,
              };
            });
          } else {
            const empTasks = proj.flatMap((p) =>
              p.Tasks.map((task) => ({
                client_name: p?.Project_name.includes('/') ? p?.Project_name.split('/')[0].trim() : '',
                project_name: p?.Project_name.includes('/') ? p?.Project_name.split('/')[1].trim() : p?.Project_name,
                Task_name: task?.Task_name,
                Priority: task?.Priority,
                Status: task?.Status,
                Hours: task?.Hours && formatTime(task.Hours),
                No_comment_hrs: getNoCommentHrs(task?.Hours, task?.Task_comments?.map(comment => comment?.Comment_hrs)),
                Task_comments: task?.Task_comments,
              }))
            );

            totalhours = proj.flatMap((p) => p.Tasks)
              .reduce((sum, task) => sum + (task?.Hours || 0), 0);

            return empTasks;
          }
        });

        EmpList = filterData;

        // Set total and employee list
        setTotalHours(formatTime(totalhours));
        setRawData(EmpList);
        console.log("EMPLOYEE CURRENT", EmpList);

      } else {
        setemployeelist([]);
        setTotalHours(formatTime(0));
      }
    }

  }, [selectedEmployee, selectedProject, sDate, eDate, Temp]);


  const tableRef = useRef(null);

  const handleExportVisibleData = () => {
    if (tableRef.current) {
      const visibleRows = tableRef.current.getPaginationRowModel().rows;
      const exportData = visibleRows.map(row => row.original);
      console.log('DATA TO BE EXPORTED', exportData)

      handleExportData(
        exportData,
        sDate,
        eDate,
        selectedTimePeriod
      );
    }
  };

  //Changed
  useEffect(() => {


    if (selectedGrouping === 'None') {

      const unGroupedData = [];

      console.log("rawDatarawData", rawData)

      rawData.forEach(task => {
        const baseData = {
          client_name: task.client_name,
          project_name: task.project_name,
          Task_name: task.Task_name,
          Priority: task.Priority,
          Status: task.Status
        };

        const hasComments = task.Task_comments && task.Task_comments.length > 0;
        const hasUncommentedHours = task.No_comment_hrs > 0;

        if (!hasComments) {
          // No comments, just one entry with No_comment_hrs (if > 0)
          if (hasUncommentedHours) {
            unGroupedData.push({
              ...baseData,
              comments_data: "No Comments",
              Hours: formatTime(task.No_comment_hrs)
            });
          }
        } else {
          // Add entries for each comment
          task.Task_comments.forEach(comment => {
            unGroupedData.push({
              ...baseData,
              comments_data: comment.content,
              Hours: comment.Comment_hrs
            });
          });

          // Also add "No Comments" if there are uncommented hours > 0
          if (hasUncommentedHours) {
            unGroupedData.push({
              ...baseData,
              comments_data: "No Comments",
              Hours: formatTime(task.No_comment_hrs)
            });
          }
        }
      });

      console.log("unGroupedData", unGroupedData);
      setemployeelist(unGroupedData);
      return;
    }


    console.log("rawDatarawData", rawData)
    const groupedData = rawData.map(task => {
      const hasComments = task.Task_comments && task.Task_comments.length > 0;

      const commentText = hasComments
        ? task.Task_comments[0].content
        : "No Comments";

      return {
        client_name: task.client_name,
        project_name: task.project_name,
        Task_name: task.Task_name,
        comments_data: commentText,
        Hours: task.Hours, // using Hours field as-is
        Priority: task.Priority,
        Status: task.Status
      };
    });

    console.log("groupedData", groupedData);

    setemployeelist(groupedData);

    return;

  }, [rawData, selectedGrouping]);

  useEffect(() => {
    if (selectedEmployee) {
      setselectedProject(1);
    }
  }, [selectedEmployee])

  return (
    <>
      {contextHolder}
      <section className='reports-section'>
        <div className="flex items-center justify-between mt-[38px] pr-[0px]" style={{ marginBottom: '-5px' }}>
          <div>
            <h2 className="page-heading">HOURS BY EMPLOYEE</h2>
          </div>

          <Button className="bg-[#3b82f6] text-[#fff] h-[33px] w-[110px]" style={{ paddingInline: '8px 10px', display: loading ? "none" : "block" }}
            // onClick={() =>
            //   handleExportData(table.getPrePaginationRowModel().rows)
            // } startIcon={<FileDownloadIcon />}
            onClick={handleExportVisibleData}
          >
            <FileDownloadIcon style={{ fontSize: '18px' }} /> Export
          </Button>
        </div>

        <div className="flex justify-start gap-[10px]">
          <div className="flex justify-start gap-[10px]">
            <Select className="z-[99] left-[10px] top-[24px]"
              style={{ width: 200 }}
              placeholder="Employee"
              value={selectedEmployee}
              showSearch
              optionFilterProp="label"
              options={Employee}
              onChange={HandleEmployee}
              disabled={loading}
            />
            <Select className="z-[99] left-[10px] top-[24px]"
              style={{ width: 200 }}
              placeholder="Projects"
              showSearch
              optionFilterProp="label"
              value={selectedProject}
              options={ProjectList}
              onChange={(e) => handletablevaluechange(e)}
              disabled={loading}
            />
          </div>
          <div className="flex justify-start gap-[10px]">
            <Select className="z-[99] left-[10px] top-[24px]"
              style={{ width: 150 }}
              placeholder="Time Period"
              value={selectedTimePeriod}
              options={options}
              onChange={handleTimePeriodChange}
              disabled={loading}
            />

            <div style={{ left: "100px" }}>
              {selectedTimePeriod === 'month' && (
                <RangePicker
                  className="z-[99] left-[10px] top-[24px] w-[235px]"
                  style={{ left: '20px' }}
                  allowClear={false}
                  defaultValue={selectedDates}
                  picker="month"
                  placeholder={['Start Month', 'End Month']}
                  format="MMMM YYYY"
                  onChange={handleDateChange}
                  disabled={loading}
                  disabledDate={(current) => {
                    // Disable future months
                    return current && current > dayjs().endOf('month');
                  }}
                />
              )}
              {selectedTimePeriod === 'year' && (
                <RangePicker
                  className="z-[99] left-[10px] top-[24px] w-[235px]"
                  style={{ left: '20px' }}
                  allowClear={false}
                  defaultValue={selectedDates}
                  picker="year"
                  placeholder={['Start Year', 'End Year']}
                  format="YYYY"
                  onChange={handleDateChange}
                  disabled={loading}
                  disabledDate={(current) => {
                    // Disable future years
                    return current && current.year() > dayjs().year();
                  }}
                />
              )}
              {selectedTimePeriod === 'week' && (
                <Flatpickr
                  className={`ant-select ant-select-outlined z-[99] left-[20px] top-[24px] w-[235px] date-picker-client-report ${loading ? 'date-picker-client-report-disabled' : 'date-picker-client-report'}`}
                  value={selectedWeekDates}
                  options={{
                    mode: "range",
                    dateFormat: "D, M j",
                    onChange: (selectedDates, dateStr, instance) => { handleWeekSelection(selectedDates, dateStr, instance); },
                    disable: [
                      function (date) {
                        const today = new Date();
                        const day = today.getDay();
                        const daysToSunday = day === 0 ? 0 : 7 - day;

                        // Get end of current week (this coming Sunday)
                        const endOfThisWeek = new Date(today);
                        endOfThisWeek.setDate(today.getDate() + daysToSunday);
                        endOfThisWeek.setHours(23, 59, 59, 999);

                        return date > endOfThisWeek; // disable any date beyond this week
                      }
                    ],

                  }}
                  noCalendar={loading}
                  placeholder="Select Week"
                />
              )}
              {selectedTimePeriod === 'date' && (
                <RangePicker
                  className="z-[99] left-[10px] top-[24px] w-[235px]"
                  style={{ left: '20px' }}
                  allowClear={false}
                  defaultValue={selectedDates}
                  placeholder={['Start Date', 'End Date']}
                  format="DD-MM-YYYY"
                  onChange={handleDateChange}
                  disabled={loading}
                  disabledDate={(current) => {
                    return current && current > dayjs().endOf('day');
                  }}


                />
              )}
            </div>
          </div>
        </div>
        <div className="mt-[-20px]  custom-table employee-table">



          {
            loading ? (<>
              <Spin tip="Loading..." className="justify-center items-center flex" style={{ height: '100vh' }}>
                <CustomTable
                  columns={columns}
                  data={[]} // totalRow
                  component={"Allocation"}
                  handleExportData={handleExportData}
                  hours={totalHours}
                />

              </Spin>
            </>

            ) : (
              <>
                <CustomTable
                  columns={columns}
                  data={[...employeelist]} // totalRow
                  component={"Allocation"}
                  handleExportData={handleExportData}
                  hours={totalHours}
                  onTableInstance={(instance) => {
                    tableRef.current = instance;
                  }}
                  setTotalHours={setTotalHours}
                  FormatTime={formatTime}
                  sidebor={sidebor}
                />
              </>
            )}

        </div>
      </section>
    </>
  );
}
